import { decodeJwt } from './accessRight';
import { getStorage } from './localstorage';

const normalizeAccessValue = (value) => String(value || '').trim().toLowerCase();

export const isDataExportFlagEnabled = () => process.env.REACT_APP_ENABLE_DATA_EXPORT === 'true'
  || (process.env.NODE_ENV === 'development'
    && process.env.REACT_APP_ENABLE_DATA_EXPORT !== 'false');

export const getDataExportAllowedUsers = () => String(process.env.REACT_APP_DATA_EXPORT_ALLOWED_USERS || '')
  .split(',')
  .map(normalizeAccessValue)
  .filter(Boolean);

export const isCurrentUserAllowedForDataExport = () => {
  const token = getStorage('token');
  const allowedUsers = getDataExportAllowedUsers();

  if (!token || !allowedUsers.length) return false;

  try {
    const decoded = decodeJwt(token);
    const currentUserKeys = [
      decoded?.EMAIL,
      decoded?.email,
      decoded?.ONE_ID,
      decoded?.one_id,
      decoded?.ONEID,
    ]
      .map(normalizeAccessValue)
      .filter(Boolean);

    return currentUserKeys.some((key) => allowedUsers.includes(key));
  } catch (error) {
    return false;
  }
};

export const canAccessDataExport = () => (
  isDataExportFlagEnabled() || isCurrentUserAllowedForDataExport()
);

export const shouldShowDataExportMenu = () => canAccessDataExport();
